import React, { useEffect, useState } from 'react';
import {
  FormControl,
  Select,
  CardMedia,
  Card,
  CardContent,
  Typography,
  MenuItem,
  TextField,
  Container,
  CircularProgress,
} from '@material-ui/core';

import { useStyles } from './styles';

interface propsChartContainer {
  titleChart?: string;
  datePicker?: boolean;
  yearsPicker?: boolean;
  yearPicker?: boolean;
  loading: boolean;
  setStartDate?: React.Dispatch<React.SetStateAction<Date>>;
  setEndDate?: React.Dispatch<React.SetStateAction<Date>>;
  setStartYear?: React.Dispatch<React.SetStateAction<Date>>;
  setEndYear?: React.Dispatch<React.SetStateAction<Date>>;
  datetime_begin?: string,
  datetime_end?: string,
}

interface Year {
  value: number;
}

const ChartContainer: React.FC<propsChartContainer> = ({
  titleChart,
  datePicker,
  yearsPicker,
  yearPicker,
  children,
  loading,
  setStartDate,
  setEndDate,
  datetime_begin,
  datetime_end
}) => {
  const styles = useStyles();

  const [year, setYear] = useState<Year[]>([]);
  const [selectYear, setSelectYear] = useState<number>();
  const [selectYearsStart, setSelectYearsStart] = useState<number>();
  const [selectYearsEnd, setSelectYearsEnd] = useState<number>();

  const [startDatePainel, setStartDatePainel] = useState<string>();
  const [endDatePainel, setEndDatePainel] = useState<string>();

  useEffect(() => {
    const loadDate = () => {
      if (datetime_begin && datetime_end) {
        const datetimebegin = datetime_begin.split("-").join(" ").split("T")[0].split(" ");
        const datetimeend = datetime_end.split("-").join(" ").split("T")[0].split(" ");
        setStartDatePainel(`${datetimebegin[0]}-${datetimebegin[1]}-${datetimebegin[2]}`);
        setEndDatePainel(`${datetimeend[0]}-${datetimeend[1]}-${datetimeend[2]}`);

        const years: Year[] = [];
        if (startDatePainel &&
          endDatePainel) {
          const initYear = Number(datetimebegin[0]);
          const endYear = Number(datetimeend[0]);
          for (let i = initYear; i <= endYear; i += 1) {
            years.push({ value: i });
          }
          setYear(years);
        }
      }
    }
    loadDate();
  }, [datetime_begin, datetime_end, startDatePainel, endDatePainel]);

  const handleChange = {
    addStartDate(event: React.ChangeEvent<{ value: unknown }>) {
      const startDate = new Date(event.target.value as Date);
      if (setStartDate) {
        setStartDate(startDate);
      }
    },
    addEndDate(event: React.ChangeEvent<{ value: unknown }>) {
      const endDate = new Date(event.target.value as Date);
      if (setEndDate) {
        setEndDate(endDate);
      }
    },
  };

  const handleChangeYears = {
    addStartDate(event: React.ChangeEvent<{ value: unknown }>) {
      const startDate = new Date(`01/01/${event.target.value}`);

      if (setStartDate) {
        setStartDate(startDate);
      }
    },
    addEndDate(event: React.ChangeEvent<{ value: unknown }>) {
      const endDate = new Date(`12/31/${event.target.value}`);
      if (setEndDate) {
        setEndDate(endDate);
      }
    },
  };

  const handleChangeYear = {
    addStartDate(event: React.ChangeEvent<{ value: unknown }>) {
      const startDate = new Date(`01/01/${event.target.value}`);
      const endDate = new Date(`12/31/${event.target.value}`);
      if (setStartDate && setEndDate) {
        setStartDate(startDate);
        setEndDate(endDate);
      }
    },

  };

  return (
    <>
      <Card className={styles.root}>
        <CardMedia className={styles.chartBar}>
          <Typography className={styles.title}>{titleChart}</Typography>
          {datePicker && (
            <Container className={styles.containerFormControl}>
              <FormControl
                margin="dense"
                className={styles.formControl}
                variant="outlined"
              >
                <TextField
                  onChange={handleChange.addStartDate}
                  id="date"
                  type="date"
                  defaultValue="2015-07-12"
                  className={styles.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl
                margin="dense"
                className={styles.formControl}
                variant="outlined"
              >
                <TextField
                  onChange={handleChange.addEndDate}
                  id="date"
                  type="date"
                  defaultValue="2019-10-12"
                  className={styles.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Container>
          )}
          {yearsPicker && (
            <>
              <Container className={styles.containerFormControl}>
                <FormControl
                  margin="dense"
                  className={`${styles.formControlSelect} ${styles.formControl}`}
                >
                  <Select
                    value={selectYearsEnd || year.length !== 0 && year[0].value}
                    labelId="demo-simple-select-filled-label"
                    id="date"
                    onChange={handleChangeYears.addStartDate}
                  >
                    {year &&
                      year.map((item) => {
                        return (
                          <MenuItem
                            className={styles.textField}
                            value={item.value}
                            key={item.value}
                            onClick={() => setSelectYearsEnd(item.value)}
                          >
                            {item.value}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                <FormControl
                  margin="dense"
                  className={`${styles.formControlSelect} ${styles.formControl}`}
                >
                  <Select
                    value={selectYearsStart || year.length !== 0 && year[year.length - 1].value}
                    labelId="demo-simple-select-filled-label"
                    id="date"
                    onChange={handleChangeYears.addEndDate}
                  >
                    {year &&
                      year.map((item) => {
                        return (
                          <MenuItem
                            className={styles.textField}
                            value={item.value}
                            key={item.value}
                            onClick={() => setSelectYearsStart(item.value)}
                          >
                            {item.value}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Container>
            </>
          )}
          {yearPicker && (
            <Container className={styles.containerFormControl}>
              <FormControl
                margin="dense"
                className={`${styles.formControlSelect} ${styles.formControl}`}
              >
                <Select
                  value={selectYear || year.length !== 0 && year[year.length - 1].value}
                  labelId="demo-simple-select-filled-label"
                  id="date"
                  onChange={handleChangeYear.addStartDate}
                >
                  {year &&
                    year.map((item) => {
                      return (
                        <MenuItem
                          className={styles.textField}
                          value={item.value}
                          key={item.value}
                          onClick={() => setSelectYear(item.value)}
                        >
                          {item.value}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Container>
          )}
        </CardMedia>
        <CardContent className={styles.cardContent}>
          {loading ? (
            <div className={styles.loadingContainer}>
              <CircularProgress
                className={styles.loadingSpinner}
                size={60}
                thickness={5}
              />
            </div>
          ) : (
              children
            )}
        </CardContent>
      </Card>
    </>
  );
};
export default ChartContainer;
